import { Branch } from '@/api/model/branch'
import { Pipeline } from '@/api/model/pipeline'

export class PipelineLinkedBranch {

    constructor(
        public pipeline: Pipeline|null,
        public branch: Branch,
        public potentialOrderValuePerReferral: number|null,
        public conversionPercentage: number|null,
    ) {}

    static fromData(data: any): PipelineLinkedBranch {
        if (data === null || typeof data === 'string' || data instanceof PipelineLinkedBranch) {
            return data
        }

        return new PipelineLinkedBranch(
            data.pipeline ? Pipeline.fromData(data.pipeline) : null,
            data.branch ? Branch.fromData(data.branch) : null,
            data.potentialOrderValuePerReferral,
            data.conversionPercentage,
        )
    }
}
